import {Dispatch} from "redux";
import {OfferDto} from "../../models/dtos/offer.dto";
import {SET_SELECTED_OFFER} from "./constants";
import {SetSelectedOfferAction} from "./types";

const setSelectedOfferAction = (payload: OfferDto): SetSelectedOfferAction => {
  return {
    type: SET_SELECTED_OFFER,
    payload: payload,
  };
}

export const setSelectedOffer = (offer: OfferDto) => async (
  dispatch: Dispatch
) => {
  dispatch(setSelectedOfferAction(offer));
};
